(function () {
    'use strict';

    angular
        .module('app')
        .controller('MarginController', MarginController);

    function MarginController($scope, $cookies, $location, $state, $rootScope, $window, BrandService, ELCService) {
        var model = this;

        $scope.permissionDenied = function () {
            $state.go('permissionDenied');

        }

        //check permissions
        angular.forEach($rootScope.userPermissions, function (userPermissionRow) {
            if (userPermissionRow[0] == 10) {
                if (userPermissionRow[1] == 2) {
                    model.CalcEditPerm = true;
                }
            }
        });

        

        if (!model.CalcEditPerm) {
            $scope.permissionDenied();
        }
        
        model.brands = [];
        model.brand = { selectedBrandId: "" }
        //model.elcInputs = {
        //    ElcBrandDefualtId: 0,
        //    BrandId: 0,
        //    Freight: 1.33,
        //    Inflation: 2,
        //    Discount: 6,
        //    SourceComm: 3,
        //    Increment: 2.5,
        //    RetailMU: 2.8,
        //    Royalty: 2.6,
        //    BuyAgentComm: 2.6,
        //    MSRP: 100,
        //    FOB: 50
        //};
        model.msrpset = [];
        model.duty1 = 0;
        model.duty2 = 2;
        model.duty3 = 4.3;
        model.duty4 = 6.0;
        model.duty5 = 8.5;
        model.duty6 = 9.0;
        model.duty7 = 10.0;
        model.duty8 = 12.0;
        model.duty9 = 20.0;
        model.duty10 = 27.6;
        model.duty11 = 37.5;

        model.brandSelected = function () {
            ELCService.getBrandDefaultsByBrandId(model.brand.selectedBrandId).then(function (data) {
                model.elcInputs = data;
                model.calcMargins();
            });
        }

        model.calcMargins = function () {
            var msrpEntered = parseInt(model.elcInputs.MSRP);
            model.msrpset = [];
            if (msrpEntered > 0) {
                for (var i = 1; i <= 33; i += 1) {
                    var msrpItem = {};
                    msrpItem.value = msrpEntered;
                    var freight = parseMarginInput(model.elcInputs.Freight);
                    var inflation = parseMarginInput(model.elcInputs.Inflation);
                    inflation = inflation / 100;
                    var discount = parseMarginInput(model.elcInputs.Discount);
                    discount = discount / 100;
                    var sourceCommish = parseMarginInput(model.elcInputs.SourceComm);
                    sourceCommish = sourceCommish / 100;
                    var admin = parseMarginInput(model.elcInputs.Admin);
                    admin = admin / 100;
                    var misc = parseMarginInput(model.elcInputs.Misc);
                    misc = misc / 100;
                    var retailMU = parseMarginInput(model.elcInputs.RetailMU);
                    retailMU = retailMU / 100;
                    var increment = parseMarginInput(model.elcInputs.Increment);
                    increment = increment / 100;
                    var fob = parseMarginInput(model.elcInputs.FOB);

                    var duty = parseMarginInput(model.duty1);
                    duty = duty / 100;
                    msrpItem.duty1Margin = calcMargin(duty, msrpEntered, retailMU, discount, fob, sourceCommish, freight, increment, inflation, admin, misc, true);
                    
                    var duty = parseMarginInput(model.duty2);
                    duty = duty / 100;
                    msrpItem.duty2Margin = calcMargin(duty, msrpEntered, retailMU, discount, fob, sourceCommish, freight, increment, inflation, admin, misc, true);
                    
                    var duty = parseMarginInput(model.duty3);
                    duty = duty / 100;
                    msrpItem.duty3Margin = calcMargin(duty, msrpEntered, retailMU, discount, fob, sourceCommish, freight, increment, inflation, admin, misc, true);

                    var duty = parseMarginInput(model.duty4);
                    duty = duty / 100;
                    msrpItem.duty4Margin = calcMargin(duty, msrpEntered, retailMU, discount, fob, sourceCommish, freight, increment, inflation, admin, misc, true);

                    var duty = parseMarginInput(model.duty5);
                    duty = duty / 100;
                    msrpItem.duty5Margin = calcMargin(duty, msrpEntered, retailMU, discount, fob, sourceCommish, freight, increment, inflation, admin, misc, true);

                    var duty = parseMarginInput(model.duty6);
                    duty = duty / 100;
                    msrpItem.duty6Margin = calcMargin(duty, msrpEntered, retailMU, discount, fob, sourceCommish, freight, increment, inflation, admin, misc, true);

                    var duty = parseMarginInput(model.duty7);
                    duty = duty / 100;
                    msrpItem.duty7Margin = calcMargin(duty, msrpEntered, retailMU, discount, fob, sourceCommish, freight, increment, inflation, admin, misc, true);

                    var duty = parseMarginInput(model.duty8);
                    duty = duty / 100;
                    msrpItem.duty8Margin = calcMargin(duty, msrpEntered, retailMU, discount, fob, sourceCommish, freight, increment, inflation, admin, misc, true);

                    var duty = parseMarginInput(model.duty9);
                    duty = duty / 100;
                    msrpItem.duty9Margin = calcMargin(duty, msrpEntered, retailMU, discount, fob, sourceCommish, freight, increment, inflation, admin, misc, true);

                    var duty = parseMarginInput(model.duty10);
                    duty = duty / 100;
                    msrpItem.duty10Margin = calcMargin(duty, msrpEntered, retailMU, discount, fob, sourceCommish, freight, increment, inflation, admin, misc, true);

                    var duty = parseMarginInput(model.duty11);
                    duty = duty / 100;
                    msrpItem.duty11Margin = calcMargin(duty, msrpEntered, retailMU, discount, fob, sourceCommish, freight, increment, inflation, admin, misc, true);

                    model.msrpset.push(msrpItem);
                    msrpEntered += 5;
                }
            }
        }

        function parseMarginInput(value)
        {
            var result = parseFloat(value);
            if (isNaN(result)) {
                result = 0;
            }
            return result;
        }

        function calcMargin(duty, msrpEntered, retailMU, discount, fob, sourceCommish, freight, increment, inflation, admin, misc, handleNaN) {

            var margin = (((msrpEntered * retailMU) * (1 - discount)) - ((fob / (1 + sourceCommish + admin + misc)) + ((fob / (1 + sourceCommish + admin + misc)) * duty) + freight + ((fob / (1 + sourceCommish + admin + misc)) * (sourceCommish + admin + misc + increment)))) * (1 - inflation) / ((msrpEntered * retailMU) * (1 - discount));
            //var margin = (((msrpEntered * retailMU) * (1 - discount)) - ((fob / (1 + sourceCommish)) + ((fob / (1 + sourceCommish)) * duty) + freight + ((fob / (1 + sourceCommish)) * (sourceCommish + increment)))) * (1 - inflation) / ((msrpEntered * retailMU) * (1 - discount));
            if (margin < 0) {
                margin = Math.ceil(margin * 100);
            }
            else {
                margin = Math.floor(margin * 100);
            }
            if (handleNaN) {
                if (isNaN(margin)) {
                    margin = 0;
                }
            }
            return margin;
        }

        function getBrandList() {
            BrandService.getBrandsByUser().then(function (data) {
                model.brands = data;
            });
        }

        function InitPage() {
            getBrandList();
        }

        InitPage();
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .controller('FobController', FobController);

    function FobController($scope, $cookies, $location, $state, $rootScope, $window, BrandService, ELCService) {
        var model = this;

        $scope.permissionDenied = function () {
            $state.go('permissionDenied');

        }

        //check permissions
        angular.forEach($rootScope.userPermissions, function (userPermissionRow) {
            if (userPermissionRow[0] == 10) {
                if (userPermissionRow[1] == 2) {
                    model.CalcEditPerm = true;
                }
            }
        });

        if (!model.CalcEditPerm) {
            $state.go('permissionDenied');
        }

        model.brands = [];
        model.selectedBrandId = "";
        //model.elcInputs = {
        //    ElcBrandDefualtId: 0,
        //    BrandId: 0,
        //    Freight: 1.33,
        //    Inflation: 2,
        //    Discount: 6,
        //    SourceComm: 3,
        //    Increment: 2.5,
        //    RetailMU: 2.8,
        //    Royalty: 2.6,
        //    BuyAgentComm: 2.6,
        //    MSRP: 50,
        //    Duty: 9
        //};
        model.elcSettings = {
            IsDutyAuto: true,
            DutyAutoText: 'Changing the first margin auto updates the others'
        };
        model.msrpset = [];
        model.margin1 = 35;
        model.margin2 = 36;
        model.margin3 = 37;
        model.margin4 = 38;
        model.margin5 = 39;
        model.margin6 = 40;
        model.margin7 = 41;
        model.margin8 = 42;
        model.margin9 = 43;
        model.margin10 = 44;
        model.margin11 = 45;
        model.margin12 = 46;
        model.margin13 = 47;
        model.margin14 = 48;
        model.margin15 = 49;
        model.margin16 = 50;
        model.margin17 = 51;

        model.isDutyAutoClicked = function () {
            //if (model.elcSettings.IsDutyAuto) {
            //    //model.elcSettings.DutyAutoText = model.CONST_AUTO_CHECKED_TEXT;
            //}
            //else {
            //    //model.elcSettings.DutyAutoText = model.CONST_AUTO_UNCHECKED_TEXT;
            //}
        }

        model.firstMarginKeyUp = function () {
            if (model.elcSettings.IsDutyAuto) {
                try{
                    model.margin2 = parseInt(model.margin1) + 1;
                    model.margin3 = parseInt(model.margin2) + 1;
                    model.margin4 = parseInt(model.margin3) + 1;
                    model.margin5 = parseInt(model.margin4) + 1;
                    model.margin6 = parseInt(model.margin5) + 1;
                    model.margin7 = parseInt(model.margin6) + 1;
                    model.margin8 = parseInt(model.margin7) + 1;
                    model.margin9 = parseInt(model.margin8) + 1;
                    model.margin10 = parseInt(model.margin9) + 1;
                    model.margin11 = parseInt(model.margin10) + 1;
                    model.margin12 = parseInt(model.margin11) + 1;
                    model.margin13 = parseInt(model.margin12) + 1;
                    model.margin14 = parseInt(model.margin13) + 1;
                    model.margin15 = parseInt(model.margin14) + 1;
                    model.margin16 = parseInt(model.margin15) + 1;
                    model.margin17 = parseInt(model.margin16) + 1;
                }
                catch(err)
                {}
            }

            model.calcFOBs();
        }

        model.brandSelected = function () {
            ELCService.getBrandDefaultsByBrandId(model.selectedBrandId).then(function (data) {
                model.elcInputs = data;
                model.calcFOBs();
            });
        }

        model.calcFOBs = function () {
            var msrpEntered = parseInt(model.elcInputs.MSRP);
            model.msrpset = [];
            if (msrpEntered > 0) {
                for (var i = 1; i <= 33; i += 1) {
                    var msrpItem = {};
                    msrpItem.value = msrpEntered;
                    var freight = parseMarginInput(model.elcInputs.Freight);
                    var inflation = parseMarginInput(model.elcInputs.Inflation);
                    inflation = inflation / 100;
                    var discount = parseMarginInput(model.elcInputs.Discount);
                    discount = discount / 100;
                    var sourceCommish = parseMarginInput(model.elcInputs.SourceComm);
                    sourceCommish = sourceCommish / 100;
                    var admin = parseMarginInput(model.elcInputs.Admin);
                    admin = admin / 100;
                    var misc = parseMarginInput(model.elcInputs.Misc);
                    misc = misc / 100;
                    var retailMU = parseMarginInput(model.elcInputs.RetailMU);
                    retailMU = retailMU / 100;
                    var increment = parseMarginInput(model.elcInputs.Increment);
                    increment = increment / 100;
                    var duty = parseMarginInput(model.elcInputs.Duty);
                    duty = duty / 100;

                    var margin = parseMarginInput(model.margin1);
                    margin = margin / 100;
                    msrpItem.margin1FOB = calcFOB(margin, sourceCommish, msrpEntered, retailMU, discount, freight, increment, duty, inflation, admin, misc, true);

                    var margin = parseMarginInput(model.margin2);
                    margin = margin / 100;
                    msrpItem.margin2FOB = calcFOB(margin, sourceCommish, msrpEntered, retailMU, discount, freight, increment, duty, inflation, admin, misc, true);
                    
                    var margin = parseMarginInput(model.margin3);
                    margin = margin / 100;
                    msrpItem.margin3FOB = calcFOB(margin, sourceCommish, msrpEntered, retailMU, discount, freight, increment, duty, inflation, admin, misc, true);

                    var margin = parseMarginInput(model.margin4);
                    margin = margin / 100;
                    msrpItem.margin4FOB = calcFOB(margin, sourceCommish, msrpEntered, retailMU, discount, freight, increment, duty, inflation, admin, misc, true);
                    
                    var margin = parseMarginInput(model.margin5);
                    margin = margin / 100;
                    msrpItem.margin5FOB = calcFOB(margin, sourceCommish, msrpEntered, retailMU, discount, freight, increment, duty, inflation, admin, misc, true);
                    
                    var margin = parseMarginInput(model.margin6);
                    margin = margin / 100;
                    msrpItem.margin6FOB = calcFOB(margin, sourceCommish, msrpEntered, retailMU, discount, freight, increment, duty, inflation, admin, misc, true);
                    
                    var margin = parseMarginInput(model.margin7);
                    margin = margin / 100;
                    msrpItem.margin7FOB = calcFOB(margin, sourceCommish, msrpEntered, retailMU, discount, freight, increment, duty, inflation, admin, misc, true);
                    
                    var margin = parseMarginInput(model.margin8);
                    margin = margin / 100;
                    msrpItem.margin8FOB = calcFOB(margin, sourceCommish, msrpEntered, retailMU, discount, freight, increment, duty, inflation, admin, misc, true);
                    
                    var margin = parseMarginInput(model.margin9);
                    margin = margin / 100;
                    msrpItem.margin9FOB = calcFOB(margin, sourceCommish, msrpEntered, retailMU, discount, freight, increment, duty, inflation, admin, misc, true);

                    var margin = parseMarginInput(model.margin10);
                    margin = margin / 100;
                    msrpItem.margin10FOB = calcFOB(margin, sourceCommish, msrpEntered, retailMU, discount, freight, increment, duty, inflation, admin, misc, true);
                    
                    var margin = parseMarginInput(model.margin11);
                    margin = margin / 100;
                    msrpItem.margin11FOB = calcFOB(margin, sourceCommish, msrpEntered, retailMU, discount, freight, increment, duty, inflation, admin, misc, true);

                    var margin = parseMarginInput(model.margin12);
                    margin = margin / 100;
                    msrpItem.margin12FOB = calcFOB(margin, sourceCommish, msrpEntered, retailMU, discount, freight, increment, duty, inflation, admin, misc, true);
                    
                    var margin = parseMarginInput(model.margin13);
                    margin = margin / 100;
                    msrpItem.margin13FOB = calcFOB(margin, sourceCommish, msrpEntered, retailMU, discount, freight, increment, duty, inflation, admin, misc, true);

                    var margin = parseMarginInput(model.margin14);
                    margin = margin / 100;
                    msrpItem.margin14FOB = calcFOB(margin, sourceCommish, msrpEntered, retailMU, discount, freight, increment, duty, inflation, admin, misc, true);

                    var margin = parseMarginInput(model.margin15);
                    margin = margin / 100;
                    msrpItem.margin15FOB = calcFOB(margin, sourceCommish, msrpEntered, retailMU, discount, freight, increment, duty, inflation, admin, misc, true);

                    var margin = parseMarginInput(model.margin16);
                    margin = margin / 100;
                    msrpItem.margin16FOB = calcFOB(margin, sourceCommish, msrpEntered, retailMU, discount, freight, increment, duty, inflation, admin, misc, true);

                    var margin = parseMarginInput(model.margin17);
                    margin = margin / 100;
                    msrpItem.margin17FOB = calcFOB(margin, sourceCommish, msrpEntered, retailMU, discount, freight, increment, duty, inflation, admin, misc, true);

                    model.msrpset.push(msrpItem);
                    msrpEntered += 5;
                }
            }
        }

        function parseMarginInput(value) {
            var result = parseFloat(value);
            if (isNaN(result)) {
                result = 0;
            }
            return result;
        }

        function calcFOB(margin, sourceCommish, msrpEntered, retailMU, discount, freight, increment, duty, inflation, admin, misc, handleNaN) {
            var margin = (((1 + sourceCommish + admin + misc) * (((msrpEntered * retailMU) * (1 - discount)) - (margin * ((msrpEntered * retailMU) * (1 - discount)))) - (freight * (1 + sourceCommish + admin + misc))) / (1 + sourceCommish + admin + misc + increment + duty)) * (1 - inflation);
            if (handleNaN) {
                if (isNaN(margin)) {
                    margin = 0;
                }
            }
            return margin;
        }

        function getBrandList() {
            BrandService.getBrandsByUser().then(function (data) {
                model.brands = data;
            });
        }

        function InitPage() {
            getBrandList();
        }

        InitPage();
    }

})();
